import { MultimediaManagerDialogItem } from './multimedia-manager-dialog/multimedia-manager-dialog-item.model';
import { Injectable } from '@angular/core';
import { MultimediaManagerDialogSidenavFolder } from './multimedia-manager-dialog-sidenav/multimedia-manager-dialog-sidenav-folder.model';

@Injectable({
  providedIn: 'root'
})
export class ParserService {

  constructor() { }

  public parseFolder(folder) {
    const multimediaManagerDialogSidenavFolder = new MultimediaManagerDialogSidenavFolder();
    folder.internalId ? multimediaManagerDialogSidenavFolder.InternalId = folder.internalId : multimediaManagerDialogSidenavFolder.InternalId = null;
    folder.name ? multimediaManagerDialogSidenavFolder.Name = folder.name : multimediaManagerDialogSidenavFolder.Name = 'unknown';
    folder.editable ? multimediaManagerDialogSidenavFolder.Editable = folder.editable : multimediaManagerDialogSidenavFolder.Editable = false;
    folder.fatherFolderInternalId ? multimediaManagerDialogSidenavFolder.FatherFolderInternalId = folder.fatherFolderInternalId : multimediaManagerDialogSidenavFolder.FatherFolderInternalId = null;
    multimediaManagerDialogSidenavFolder.Editing = false;
    return multimediaManagerDialogSidenavFolder;
  }

  public parseItem(element) {
    const item = new MultimediaManagerDialogItem();
    element.editable ? item.Editable = element.editable : item.Editable = false;
    element.internalId ? item.InternalId = element.internalId : item.InternalId = null;
    element.name ? item.Name = element.name : item.Name = 'Unknown name';
    element.size ? item.Size = element.size : item.Size = null;
    element.url ? item.Url = element.url : item.Url = null;
    element.urlThumbnail ? item.UrlThumbnail = element.urlThumbnail : item.UrlThumbnail = null;
    element.type ? item.Type = element.type : item.Type = null;
    element.fatherFolderInternalId ? item.FatherFolderInternalId = element.fatherFolderInternalId : item.FatherFolderInternalId = null;
    return item;
  }
}
